import Link from 'next/link';
import NoAffiliateAuthModal from '@components/common/modals/affiliateModal/noAffiliateAuthModal';
import Text from '@components/common/text';
import Icon from '@components/common/assets';
import LoginModal from '@components/loginModal';
import InfoDetailRecommendList from '@components/info/detail/recommend/list';
import { useInfoDetail } from '@repository/post/usePost';
import { InfoCardVO } from '@domain/vo/info/infoCardVO';
import { FontStyle } from '@domain/constant/fontStyle';
import useContentAccessControl from '@utils/hooks/useContentAccessControl';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const Recommend = () => {
  const { data: detailData } = useInfoDetail(455);
  const cardList = detailData?.postCards.map((card) => new InfoCardVO(card));

  const {
    handleCardClick,
    loginModalVisible,
    noAffiliateAuthModalVisible,
    redirectUrl,
    setLoginModalVisible,
    setNoAffiliateAuthModalVisible,
    noAffiliateAuthModalTitle,
  } = useContentAccessControl();

  if (!detailData) return null;

  return (
    <div>
      <div className={cx('titleArea')}>
        <Text fontStyle={FontStyle.H4_B}>당신이 좋아할 콘텐츠만 잡아봤어요.</Text>
        <Link href={RouteUrl.INFO_LIST}>
          <Text fontStyle={FontStyle.B3P_M} styles={{ display: 'flex', alignItems: 'center' }}>
            전체보기
            <Icon name="arrowRightLight" width={24} height={24} />
          </Text>
        </Link>
      </div>
      <InfoDetailRecommendList cardList={cardList} handleClick={handleCardClick} />

      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={loginModalVisible}
        onClose={() => setLoginModalVisible(false)}
        redirectUrl={redirectUrl}
      />
      <NoAffiliateAuthModal
        title={noAffiliateAuthModalTitle}
        visible={noAffiliateAuthModalVisible}
        onClose={() => setNoAffiliateAuthModalVisible(false)}
      />
    </div>
  );
};

export default Recommend;
